export default __webpack_public_path__ + "a4d5e39caba4a4c6dd03b1765a423d7f.gif";